<template>
  <div>
    <Main
      ref="tableMain"
      :loading="loading"
      :tableData="tableData"
      :disabled="disabled"
      @openDetailDialog="openDetailDialog"
      @openAddDialog="openAddDialog"
      @reload="() => $refs.tableHeader.query()"
      @batchDel="submitDel"
    >
      <Header
        ref="tableHeader"
        slot="header"
        :disabled="disabled"
        @openAddDialog="openAddDialog"
        @query="getData"
        @batchDel="batchDel"
      />
    </Main>
    <GoodsDetailDialog
      v-if="goodsDetailDialogParams.visible"
      :changeOrderCode="changeOrderCode"
      :disabled="goodsDetailDialogParams.disabled"
      :visible="goodsDetailDialogParams.visible"
      :title="goodsDetailDialogParams.title"
      :types="goodsDetailDialogParams.types"
      :changeOrderGoodsCode="goodsDetailDialogParams.code"
      @reload="() => $refs.tableHeader.query()"
      @close="() => (goodsDetailDialogParams.visible = false)"
      ref="goodsDetailDialog"
    />
    <GoodsAddDialog
      v-if="goodAddDialogParams.visible"
      :changeOrderCode="changeOrderCode"
      :disabled="goodAddDialogParams.disabled"
      :visible="goodAddDialogParams.visible"
      :title="goodAddDialogParams.title"
      :types="goodAddDialogParams.types"
      :changeOrderGoodsCode="goodAddDialogParams.changeOrderGoodsCode"
      :orderGoodsCode="goodAddDialogParams.orderGoodsCode"
      @reload="() => $refs.tableHeader.query()"
      @close="() => (goodAddDialogParams.visible = false)"
    />
  </div>
</template>
<script>
import Main from './main'
import Header from './header'
import GoodsDetailDialog from '../goods-detail/dialog.vue'
import GoodsAddDialog from '../goods-detail/add-dialog.vue'
export default {
  components: { Main, Header, GoodsDetailDialog, GoodsAddDialog },
  props: {
    changeOrderCode: { type: String, default: '' },
    disabled: { type: Boolean, default: false },
  },
  data() {
    return {
      tableData: [],
      loading: false,
      goodsDetailDialogParams: {
        visible: false,
        title: '',
        disabled: false,
        code: '',
        types: '',
      },
      goodAddDialogParams: {
        visible: false,
        title: '',
        disabled: false,
        orderGoodsCode: '',
        changeOrderGoodsCode: '',
        types: '',
      },
    }
  },
  mounted() {
    this.getData(this.changeOrderCode)
  },
  methods: {
    getData(form) {
      if (!this.changeOrderCode) return
      this.loading = true
      this.tableData = []
      this.$api
        .changeOrderGoodsListApi({
          changeOrderCode: this.changeOrderCode,
          ...form,
        })
        .then((res) => {
          this.loading = false
          this.tableData = res.body.data
          this.$emit('reloadOrderInfo')
        })
        .catch(() => {
          this.loading = false
        })
    },
    batchDel() {
      const listCode = this.$refs.tableMain.getCheckboxRecords()
      if (listCode) this.submitDel(listCode)
    },
    submitDel(listCode) {
      this.$confirm(
        this.$l('INDEX.tips_delete') || '是否要删除该记录？',
        this.$l('INDEX.label_completeDesc') || '确认信息',
        {
          confirmButtonText:
            this.$l('INDEX.product_dialog_btn_confirm') || '确定',
          cancelButtonText: this.$l('INDEX.btn_cancel') || '取消',
          type: 'warning',
        }
      ).then(() => {
        this.$api
          .changeOrderGoodsDelApi({
            listCode,
            changeOrderCode: this.changeOrderCode,
          })
          .then(() => {
            this.$message({
              showClose: true,
              message: this.$l('INDEX.tips_delete_ok') || '删除成功！',
              type: 'success',
            })
            this.$refs.tableHeader.query()
          })
      })
    },
    openDetailDialog({ type, code = '' }) {
      const types = {
        add: this.$l('INDEX.goods_dialog_title_add_info') || '添加订单产品信息',
        edit:
          this.$l('INDEX.goods_dialog_title_edit_info') || '编辑订单产品信息',
        detail:
          this.$l('INDEX.goods_dialog_title_detail_info') || '订单产品信息详情',
        copy: this.$l('INDEX.goods_dialog_title_copy_info') || '订单产品复制',
      }
      this.goodsDetailDialogParams = {
        visible: true,
        title: types[type],
        code,
        disabled: type === 'detail',
        types: type,
      }
    },
    openAddDialog({ type, param = {} }) {
      const types = {
        add: this.$l('INDEX.goods_dialog_title_add_info') || '添加订单产品信息',
        copy: this.$l('INDEX.goods_dialog_title_copy_info') || '订单产品复制',
      }
      this.goodAddDialogParams = {
        visible: true,
        title: types[type],
        orderGoodsCode: param.orderGoodsCode,
        changeOrderGoodsCode: param.changeOrderGoodsCode,
        disabled: type === 'detail',
        types: type,
      }
    },
  },
}
</script>
